// Formatta una durata in millisecondi in forma leggibile (italiano).
// null/undefined/NaN/negativo → '—'.
export function formatDuration(ms: number | null | undefined): string {
  if (ms == null || isNaN(ms) || ms < 0) return '—';
  const totalMin = Math.round(ms / 60000);
  if (totalMin < 60) return `${totalMin}m`;
  const totalHours = Math.floor(totalMin / 60);
  const min = totalMin % 60;
  if (totalHours < 24) return min ? `${totalHours}h ${min}m` : `${totalHours}h`;
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;
  return hours ? `${days}g ${hours}h` : `${days}g`;
}

export default formatDuration;
